import React from "react";

export const BRAND = {
  name: "Gestão Expert",
  tagline: "Sites e Sistemas",
  logo: "https://customer-assets.emergentagent.com/job_sales-hub-345/artifacts/ejhsqwlm_0FB76ACE-86A8-4509-B867-999983AF1060.png",
};

export function BrandLogo({ size = 120, animated = true, className = "" }) {
  return (
    <img
      src={BRAND.logo}
      alt={BRAND.name}
      width={size}
      height={size}
      className={`${animated ? "brand-logo" : ""} ${className}`}
      style={{ width: size, height: size, objectFit: "contain" }}
    />
  );
}

export function BrandWordmark({ className = "", small = false }) {
  return (
    <div className={`flex flex-col items-center ${className}`}>
      <h1 className={`font-display tracking-tight font-bold ${small ? "text-xl" : "text-3xl sm:text-4xl"}`}>
        <span className="text-white">Gestão </span>
        <span className="brand-name-shimmer">Expert</span>
      </h1>
      <div className="text-[10px] sm:text-xs uppercase tracking-[0.4em] text-white/50 mt-2 flex items-center gap-2">
        <span className="block w-6 h-px bg-gradient-to-r from-transparent to-blue-400"/>
        {BRAND.tagline}
        <span className="block w-6 h-px bg-gradient-to-l from-transparent to-purple-400"/>
      </div>
    </div>
  );
}

export function BrandWordmarkLight({ className = "" }) {
  return (
    <div className={`flex flex-col ${className}`}>
      <div className="font-display font-bold tracking-tight leading-none">
        <span className="text-[#0A0A0A]">Gestão </span>
        <span style={{ background: "linear-gradient(90deg, #4F46E5, #A855F7)", WebkitBackgroundClip: "text", backgroundClip: "text", color: "transparent" }}>Expert</span>
      </div>
      <div className="text-[8px] uppercase tracking-[0.25em] text-neutral-400 mt-0.5">
        {BRAND.tagline}
      </div>
    </div>
  );
}
